export const RESET_NFSE_NATURE = 'NFSE_NATURES/RESET_NFSE_NATURE';
export const SET_SUMMARY_NFSE_NATURES = 'NFSE_NATURES/SET_SUMMARY_NFSE_NATURES';
export const SET_PAGINATION_NFSE_NATURES = 'NFSE_NATURES/SET_PAGINATION_NFSE_NATURES';
export const SET_DETAILED_NFSE_NATURE = 'NFSE_NATURES/SET_DETAILED_NFSE_NATURE';
export const SET_NFSE_NATURES_WARNINGS = 'NFSE_NATURES/SET_NFSE_NATURES_WARNINGS';
